import React, { useEffect, useState } from "react";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import { getNewEMPs } from "../../../../services/clearing/emps";
import CollapsibleSection from "../../../../components/CollapsibleSection";
import SectionStatusBadge from "../SectionStatusBadge";

export const UnregisteredEmpsSection = () => {
  const [emps, setEmps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [first, setFirst] = useState(0);
  const rows = 5;

  useEffect(() => {
    const fetchEmps = async () => {
      try {
        const result = await getNewEMPs();
        if (result === false) {
          setError(true);
        } else if (Array.isArray(result)) {
          setEmps(result);
        }
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchEmps();
  }, []);

  return (
    <CollapsibleSection
      title="Unregistered EMPs"
      storageKey="clearing.unregisteredEmps"
      badge={
        <SectionStatusBadge
          loading={loading}
          error={error}
          count={emps.length}
          singular="EMP"
          plural="EMPs"
        />
      }
    >
      {loading && (
        <div className="flex align-items-center gap-2">
          <ProgressSpinner
            style={{ width: "1.5rem", height: "1.5rem" }}
            strokeWidth="4"
          />
          <span className="text-color-secondary">
            Loading unregistered EMPs...
          </span>
        </div>
      )}

      {!loading && error && (
        <div className="flex align-items-center gap-2 text-red-500">
          <i className="pi pi-times-circle" />
          <span>Failed to load unregistered EMPs.</span>
        </div>
      )}

      {!loading && !error && emps.length === 0 && (
        <div className="flex align-items-center gap-2 text-green-600">
          <i className="pi pi-check-circle text-xl" />
          <span>All EMPs are registered and assigned.</span>
        </div>
      )}

      {!loading && !error && emps.length > 0 && (
        <div className="border-1 border-round surface-border">
          {emps.slice(first, first + rows).map((id, index) => (
            <div
              key={index}
              className="p-3 border-bottom-1 surface-border hover:surface-hover transition-colors transition-duration-200"
            >
              {id}
            </div>
          ))}

          {emps.length > rows && (
            <Paginator
              first={first}
              rows={rows}
              totalRecords={emps.length}
              onPageChange={(e) => setFirst(e.first)}
            />
          )}
        </div>
      )}
    </CollapsibleSection>
  );
};
